import "./Page.css"

export default function Page({ children, className, style }) {
	return (
		<div className={"h-100 flex flex-column " + (className || "")} style={style}>
			{children}
		</div>
	)
}
